export default {
  VERSION: `${process.env.VERSION}`,
  NODE_ENV: `${process.env.NODE_ENV}`,
  SESSION_TOKEN: `${process.env.SESSION_TOKEN}`,
  AUTH_TOKEN: `${process.env.AUTH_TOKEN}`,
  PROSPECT_TOKEN: `${process.env.PROSPECT_TOKEN}`,
  WIDGETS_URL: `${process.env.WIDGETS_URL}`,
  WIDGETS_EMBED_URL: `${process.env.WIDGETS_EMBED_URL}`,
  WIDGETS_IFRAME_ORIGIN: `${process.env.WIDGETS_IFRAME_ORIGIN}`,
  TABLELIST_WEBSITE_URL: `${process.env.TABLELIST_WEBSITE_URL}`,
  TABLELIST_API_BASE_URL: `${process.env.TABLELIST_API_BASE_URL}`,
  IFRAME_MESSAGE_NAME: 'TABLELIST_IFRAME_MESSAGE',
  SEGMENT_ANALYTICS: `${process.env.SEGMENT_ANALYTICS}`,
  TERMS_URL: `${process.env.TERMS_URL}`,
  STRIPE_KEY: `${process.env.STRIPE_KEY}`,
  TL_API_KEY: `${process.env.TL_API_KEY}`,
  PUBNUB_PUB_KEY: `${process.env.PUBNUB_PUB_KEY}`,
  PUBNUB_SUB_KEY: `${process.env.PUBNUB_SUB_KEY}`,
}



// WEBPACK FOOTER //
// ./src/config.js